import * as settings from './settings/selectors'
import * as table from './table/selectors'
import * as details from './details/selectors'

export default {
  settings,
  table,
  details
}
